import React from 'react';

const UnderMaintenance = () => (
  <div className="maintenance-page">
    <span className="maintenance-icon">🛠️</span>
    <h1>We'll be back soon!</h1>
    <p>This site is currently under maintenance. Please check back shortly.</p>
  </div>
);

export default UnderMaintenance;
